export const PlanMyDayDummyMessages = [
  {
    id: "m1",
    role: "user",
    text: "Please plan my day.",
    name: "John",
    timestamp: Date.now(),
  },
  {
    id: "m2",
    role: "ai",
    text: "✅ Here is your order along with their priority.\n\n👇 Select an order to proceed.",
    timestamp: Date.now(),
    orders: [
      {
        priority: "P1",
        axonId: "US-75997",
        status: "Assigned Request",
        feedback: "Above",
        clientEntity: "Choice hotels",
        analyzer: "GLA",
        dueDate: "12 Jan, 25",
        iteration: "1",
      },
      {
        priority: "P2",
        axonId: "US-12254",
        status: "Preparing Analyzer",
        feedback: "Above",
        clientEntity: "Apex Ltd",
        analyzer: "INV",
        dueDate: "12 Jan, 25",
        iteration: "2",
      },
      {
        priority: "P3",
        axonId: "US-14324",
        status: "Data Triage",
        feedback: "Below",
        clientEntity: "Alpha Co",
        analyzer: "GLA",
        dueDate: "12 Jan, 25",
        iteration: "1",
      },
      {
        priority: "P4",
        axonId: "US-16455",
        status: "Data Received",
        feedback: "Met",
        clientEntity: "Apex Ltd",
        analyzer: "TPA",
        dueDate: "12 Jan, 25",
        iteration: "3",
      },
      {
        priority: "P5",
        axonId: "US-13455",
        status: "Preparing Analyzer",
        feedback: "Met",
        clientEntity: "Apex Ltd",
        analyzer: "TRA",
        dueDate: "12 Jan, 25",
        iteration: "2",
      },
    ],
  },
];

export const HighPriorityOrdersDummyMessages = [
  {
    id: "m1",
    role: "user",
    text: "High Priority Orders",
    name: "John",
    timestamp: Date.now(),
  },
  {
    id: "m2",
    role: "ai",
    text: "Here's your high priority orders list.\n\n👇 Select an order to proceed.",
    timestamp: Date.now(),
    orders: [
      {
        priority: "P1",
        axonId: "US-75997",
        status: "Assigned Request",
        feedback: "Above",
        clientEntity: "Choice hotels",
        analyzer: "GLA",
        dueDate: "12 Jan, 25",
        iteration: "1",
      },
      {
        priority: "P1",
        axonId: "US-12254",
        status: "Preparing Analyzer",
        feedback: "Above",
        clientEntity: "Apex Ltd",
        analyzer: "INV",
        dueDate: "12 Jan, 25",
        iteration: "2",
      },
      {
        priority: "P1",
        axonId: "US-14344",
        status: "Data Triage",
        feedback: "Below",
        clientEntity: "Alpha Co",
        analyzer: "GLA",
        dueDate: "12 Jan, 25",
        iteration: "1",
      },
      {
        priority: "P1",
        axonId: "US-16455",
        status: "Data Received",
        feedback: "Met",
        clientEntity: "Apex Ltd",
        analyzer: "TPA",
        dueDate: "12 Jan, 25",
        iteration: "3",
      },
      {
        priority: "P1",
        axonId: "US-13455",
        status: "Preparing Analyzer",
        feedback: "Met",
        clientEntity: "Apex Ltd",
        analyzer: "TRA",
        dueDate: "12 Jan, 25",
        iteration: "2",
      },
    ],
  },
];

export const MandatoryFieldsJEDummyMessages = [
  {
    id: "m1",
    role: "user",
    text: "What are mandatory fields in JE ?",
    name: "John",
    timestamp: Date.now(),
  },
  {
    id: "m2",
    role: "ai",
    text: `• JE Number - Unique identifier for each journal entry.
• GL Account Number - Must match with Trial Balance account numbers.
• Functional Amount - Amount in local (functional) currency.
• Reporting Amount - Amount in reporting currency (computed if not available).
• Reporting Currency Code - Typically "USD" or as per reporting requirements.
• Effective Date - Posting date within the analysis period.
• Period - Accounting period aligned with the effective date.`,
    timestamp: Date.now(),
  },
];

export const ReviewerUSDummyMessages = [
  {
    id: "m1",
    role: "user",
    text: "Who is the reviewer for US- XXXX ?",
    name: "John",
    timestamp: Date.now(),
  },
  {
    id: "m2",
    role: "ai",
    text: "The reviewer for order US-XXXX is currently not assigned. Please contact your team lead to assign a reviewer for this order.",
    timestamp: Date.now(),
  },
];

export const OrdersInDataTriageDummyMessages = [
  {
    id: "m1",
    role: "user",
    text: "Orders in Data Triage",
    name: "John",
    timestamp: Date.now(),
  },
  {
    id: "m2",
    role: "ai",
    text: "Here's your orders list which are currently in Data Triage.\n\n👇 Select an order to proceed.",
    timestamp: Date.now(),
    orders: [
      {
        priority: "P1",
        axonId: "US-13022",
        status: "Failed",
        feedback: "Below",
        clientEntity: "Apollo Pharma",
        analyzer: "GLA",
        dueDate: "12 Jan, 25",
        iteration: "2",
      },
      {
        priority: "P2",
        axonId: "US-12254",
        status: "Passed",
        feedback: "Above",
        clientEntity: "B Capital",
        analyzer: "INV",
        dueDate: "12 Jan, 25",
        iteration: "2",
      },
      {
        priority: "P3",
        axonId: "US-14344",
        status: "In-Progress (Triage mapping confirmation pending)",
        feedback: "Below",
        clientEntity: "Alpha Co",
        analyzer: "TRA",
        dueDate: "12 Jan, 25",
        iteration: "1",
      },
      {
        priority: "P4",
        axonId: "US-14324",
        status: "In-Progress (File Validation)",
        feedback: "Met",
        clientEntity: "Alpha Co",
        analyzer: "GLA",
        dueDate: "12 Jan, 25",
        iteration: "1",
      },
      {
        priority: "P5",
        axonId: "US-75997",
        status: "In-Progress (Data Validation)",
        feedback: "Met",
        clientEntity: "Choice hotels",
        analyzer: "GLA",
        dueDate: "12 Jan, 25",
        iteration: "1",
      },
    ],
  },
];

export const NewlyAllocatedOrdersDummyMessages = [
  {
    id: "m1",
    role: "user",
    text: "Newly Allocated Orders",
    name: "John",
    timestamp: Date.now(),
  },
  {
    id: "m2",
    role: "ai",
    text: "✅ Here's your newly allocated orders list.\n\n👇 Select an order to proceed.",
    timestamp: Date.now(),
    orders: [
      {
        priority: "P1",
        axonId: "US-14055",
        status: "Assigned Request",
        feedback: "Above",
        clientEntity:
          "Blue Cross and Blue Shield of North Carolina Hospital and Medical Service Corporation",
        analyzer: "General Ledger Analyzer",
        dueDate: "Jan 12, 25",
        iteration: "1",
      },
      {
        priority: "P2",
        axonId: "US-12254",
        status: "Assigned Request",
        feedback: "Above",
        clientEntity:
          "Blue Cross and Blue Shield of North Carolina Hospital and Medical Service Corporation",
        analyzer: "Trade Receivables Analyzer",
        dueDate: "Jan 12, 25",
        iteration: "2",
      },
      {
        priority: "P3",
        axonId: "US-14324",
        status: "Assigned Request",
        feedback: "Below",
        clientEntity:
          "Associated Industries of Massachusetts Mutual Insurance Company",
        analyzer: "FSO: State Examination Document Bot",
        dueDate: "Jan 12, 25",
        iteration: "1",
      },
      {
        priority: "P4",
        axonId: "US-16455",
        status: "Assigned Request",
        feedback: "Met",
        clientEntity:
          "Los Angeles Organizing Committee For The Olympic and Paralympic Games 2028",
        analyzer: "Sub-Ledger Analyzer - Trade Payables",
        dueDate: "Jan 12, 25",
        iteration: "3",
      },
      {
        priority: "P5",
        axonId: "US-13455",
        status: "Assigned Request",
        feedback: "Met",
        clientEntity: "Childrens Medical Center Corporation",
        analyzer: "Sub-Ledger Analyzer - Trade Receivables",
        dueDate: "Jan 12, 25",
        iteration: "2",
      },
    ],
  },
];
